import type MailFaviconStore from "./schema/MailFaviconStore";
import { createStore } from "owa-satcheljs";

const mailFaviconStoreData: MailFaviconStore = {
    areMessagesUnseen: false,
};

const defaultExport: () => MailFaviconStore = createStore<MailFaviconStore>("mailFaviconStore", mailFaviconStoreData);
export default defaultExport;
